<template>
    <GMapMap ref="gMap" :center="center" :zoom="zoom" class="fullpage-map">
        <GMapMarker v-for="pin in mapPins" :icon="pin.icon" :key="pin.id" :position="pin.location" :clickable="true" @click="openMarker(pin.id)" :draggable="pin.allowDrag" @dragend="dragEnd($event, pin)">
            <GMapInfoWindow :opened="openedMarker == pin.id" :closeclick="true" @closeclick="closeMarker(pin.id)">
                <h3>{{ pin.label }}</h3>
                <div class="address">
                    <hours-status v-if="pin.listing" :listing="pin.listing"></hours-status>
                    {{ pin.address }}
                    <template v-if="pin.address2">
                        <br />
                        {{ pin.address2 }}
                    </template>
                </div>
                <p v-if="pin.allowAction"><a :href="'#' + pin.id" :title="pin.actionTitle" @click="pinAction(pin.id)">{{ pin.actionTitle }}</a></p>
            </GMapInfoWindow>
        </GMapMarker>
    </GMapMap>
</template>


<script>
    import script from './DynamicMap';
    export default script;</script>

<style lang="less">
    @import "./DynamicMap.less";
</style>